export type FormatAnimatedNumberOptions = {
  integer?: boolean;
  locale?: string;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
};

export const formatAnimatedNumber = (
  value: number,
  {
    integer = false,
    locale = 'en-US',
    maximumFractionDigits,
    minimumFractionDigits,
  }: FormatAnimatedNumberOptions = {},
) => {
  const normalized = integer ? Math.round(value) : value;

  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: integer ? 0 : maximumFractionDigits,
    minimumFractionDigits: integer ? 0 : minimumFractionDigits,
  }).format(normalized);
};
